export enum PracticeStatus {
    PENDING = 'PENDING',
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
}
